import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
/*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
import * as MenuAction from '../actions/MenuAction';
class SearchResultsStore extends EventEmitter {
    SearchresultList = "";
    SuccessStatus = "";
    FavitemAddList = "";
    workorderresponse = "";
    ImgattachmentResponse = "";
    handleSearchResultsStore = (action) => {
        switch (action.action.type) {
            case "Searchresult": {
                this.SearchresultList = action.action.response;
                this.emit('Searchresult');
                break;
            }
            case "Img_UploadAttachments": {
                this.ImgattachmentResponse = action.action.response;
                this.emit('ImgUploadAttachments');
                break;
            }
            case "Status": {
                /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                MenuAction.refreshCartCount();
                this.SuccessStatus = action.action.response;
                this.emit('Status');
                break;
            }
            case "FavitemAdd": {
                this.FavitemAddList = action.action.response;
                this.emit('FavitemAdd');
                break;
            }
            case "SrchFavitemAdd": {
                this.FavitemAddList = action.action.response;
                this.emit('SrchFavitemAdd');
                break;
            }
            case "CheaperItem": {
                this.SearchresultList = action.action.response;
                this.emit('CheaperItem');
                break;
            }
            case "workordercheck": {
                this.workorderresponse = action.action.response;
                this.emit('workordercheck');
                break;
            }
            case "workorderfail": {
                this.workorderresponse = "fail";
                this.emit('WOfail');
                break;
            }
            case "AddToCartBypass": {
                /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                MenuAction.refreshCartCount();
                this.AddToCartBypass = action.action.response;
                this.emit('AddToCartBypass');
                break;
            }

            case "Search_DynamicForm": {
                this.Search_DynamicForm = action.action.response;
                this.emit('Search_DynamicForm');
                break;
            }
        }
    }

}

const objSearchResultsStore = new SearchResultsStore;
Dispatcher.register(objSearchResultsStore.handleSearchResultsStore.bind(objSearchResultsStore));
export default objSearchResultsStore;
